type Ids = Record<string, number>;

const ids: Ids = {
  17586: 1,
  17593: 1,
  17357: 1,

  17590: 4,
  17600: 4,
  17359: 4,

  7596108: 5,
  7596098: 5,
  7596111: 5,

  541872: 8,
  541832: 8,
  541873: 8,

  639383: 11,
  615970: 11,
  639590: 11,

  10277947: 14,
  10277938: 14,
  10395911: 14,

  13035568: 15,
  13035253: 15,
  12973983: 15,

  13035217: 16,
  13035169: 16,
  13022748: 16,

  17587: 18,
  17358: 18,
  17596: 18,
};
//['10277938', '7596098', '17587', '541832']

/*

export const FUNDS_IDS = {
  [Funds.MyFuture]: [17359, 17600, 17590],
  [Funds.MyBonds]: [17357, 17593, 17586],
  [Funds.MySafe]: [615970, 639590, 639383],
  [Funds.MyShares]: [541832, 541873, 541872],
  [Funds.MyPension]: [17358, 17596, 17587],
  [Funds.IngosstrakhInternationalMarkets]: [10277938, 10277947, 10395911],
  [Funds.IngosstrakhAdvancedTechnologies]: [13022748, 13035217, 13035169],
  [Funds.IngosstrakhPreciousMetals]: [12973983, 13035568, 13035253],
  [Funds.IngosstrakhForeignCurrencyBonds]: [7596098, 7596111, 7596108],
};
            
*/

function searchByKey(key: string): number {
  if (ids[key]) {
    return ids[key];
  }
  return 0;
}

export const FansyToEasyIdConverter = (id: string): number => searchByKey(id);
